import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../../../../../shared/services/auth.service';
import { combineLatest, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../state/app.state';
import { SaveDailyReportRequest } from '../../../../../core/projects.actions';
import { dailyReport, projectDetails, siteDetails } from '../../../../../core/projects.selectors';
import { ProjectsService } from '../../../../../core/projects.service';
import {
  BidItemDetailsWrapperComponent,
} from '../daily-report-components/detail-components/bid-item-details/bid-item-details-wrapper/bid-item-details-wrapper.component';
import {
  ItemPostingsWrapperComponent,
} from '../daily-report-components/detail-components/item-postings/item-postings-wrapper/item-postings-wrapper.component';
import { DailyReportService } from '../daily-report.service';
import {
  ActivityItemDetailsComponent,
} from '../daily-report-components/detail-components/activitiy-details/activity-item-details/activity-item-details.component';
import {
  NotesDetailsComponent,
} from '../daily-report-components/detail-components/notes-details/notes-details.component';
import {
  DeliveryDetailsWrapperComponent,
} from '../daily-report-components/detail-components/delivery-details/delivery-details-wrapper/delivery-details-wrapper.component';
import {
  UsageDetailsWrapperComponent,
} from '../daily-report-components/detail-components/usage-details/usage-details-wrapper/usage-details-wrapper.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../../shared/components';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import {
  LaborDetailsWrapperComponent,
} from '../daily-report-components/detail-components/labor-details/labor-details-wrapper/labor-details-wrapper.component';
import {
  EquipmentDetailsWrapperComponent,
} from '../daily-report-components/detail-components/equipment-details/equipment-details-wrapper/equipment-details-wrapper.component';
import * as $ from 'jquery';
import { MatTabGroup } from '@angular/material/tabs';
import {
  WeatherDetailsWrapperComponent,
} from '../daily-report-components/detail-components/weather-details/weather-details-wrapper/weather-details-wrapper.component';
import {
  IssueDetailsWrapperComponent,
} from '../daily-report-components/detail-components/issue-details/issue-details-wrapper/issue-details-wrapper.component';
import {
  InternalTestDetailsWrapperComponent,
} from '../daily-report-components/detail-components/internal-test-details/internal-test-details-wrapper/internal-test-details-wrapper.component';
import { appDataDetails, translations } from '../../../../../../../shared/core/shared.selectors';
import {
  ActivityCodesDetailsWrapperComponent,
} from '../daily-report-components/detail-components/activity-codes-details/activity-codes-details-wrapper/activity-codes-details-wrapper.component';
import {
  ControlFormDetailsWrapperComponent,
} from '../daily-report-components/detail-components/control-forms-details/control-form-details-wrapper/control-form-details-wrapper.component';
import {
  GenericFormWrapperComponent,
} from '../daily-report-components/detail-components/generic-form/generic-form-wrapper/generic-form-wrapper.component';
import { Ability, subject } from '@casl/ability';
import {
  TestingFormDetailsWrapperComponent,
} from '../daily-report-components/detail-components/testing-form-details/testing-form-details-wrapper/testing-form-details-wrapper.component';
import {
  WorkdayDetailsWrapperComponent,
} from '../daily-report-components/detail-components/workday-details/workday-details-wrapper/workday-details-wrapper.component';
import {
  ExternalTestDetailsWrapperComponent,
} from '../daily-report-components/detail-components/external-test-details/external-test-details-wrapper/external-test-details-wrapper.component';
import {
  CleContractorDetailsWrapperComponent,
} from '../daily-report-components/detail-components/contractor-details/cle-contractor-details-wrapper/cle-contractor-details-wrapper.component';
import {
  CleLaborDetailsWrapperComponent,
} from '../daily-report-components/detail-components/contractor-details/cle-labor-details-wrapper/cle-labor-details-wrapper.component';
import {
  CleEquipmentDetailsWrapperComponent,
} from '../daily-report-components/detail-components/contractor-details/cle-equipment-details-wrapper/cle-equipment-details-wrapper.component';
import { mergeLineItems } from '../line-item-merge.utils';
import { carryOverUnsentList, normalizeReportLineItemIds, relationId, toIdList, withRelationIds } from '../report-line-item-ids.utils';
import {
  projectForRoute,
  resolveWidgetConfig,
  WidgetConfigEntry,
} from '../../../../../../../shared/helpers/project-widget-config';
import { withLinkPayloads } from '../../../../../../../shared/helpers/design-context';
import { baseUpdatedAtFor } from '../../../../../../../shared/helpers/report-conflict';
import { isIssueStatusClosed, isIssueStatusOpen } from '../../../../../../../shared/helpers/issue-workflow';
@Component({
    selector: 'app-daily-report-two',
    templateUrl: './daily-report.component.html',
    styleUrls: ['./daily-report.component.scss'],
    standalone: false
})
export class DailyReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('deliveryUsageTabs') deliveryUsageTabs: MatTabGroup;
  @ViewChild('laborEquipmentTabs') laborEquipmentTabs: MatTabGroup;
  @ViewChild('cleTabs') cleTabs: MatTabGroup;
  @ViewChild('materialTestingTabs') materialTestingTabs: MatTabGroup;
  weather: any = {};
  bidItems: any[] = [];
  deliveries: any[] = [];
  usages: any[] = [];
  materialTesting: any = {};
  issues: any[] = [];
  activities: any[] = [];
  notes: any[] = [];
  labors: any[] = [];
  equipments: any[] = [];
  openIssues: any[] = [];
  closedIssues: any[] = [];
  expandedSection = '';
  dailyReport: any;
  reportId: any;
  site: any;
  project: any;
  deliveriesCount = 0;
  usagesCount = 0;
  internalMaterialTestingCount = 0;
  externalMaterialTestingCount = 0;
  laborCount = 0;
  equipmentCount = 0;
  contractors: any[] = [];
  contractorCount = 0;
  selectedId: string;
  expandedSectionTabIndex = 0;
  isOpenIssuesPanelExpanded = false;
  private autoOpenedSelectedId: string | null = null;
  isClosedIssuesPanelExpanded = false;
  isOpenTestPanelExpanded = false;
  isClosedTestPanelExpanded = false;
  isItemPostingsPanelExpanded = false;
  isContractorPanelExpanded = false;
  isLaborPanelExpanded = false;
  isEquipmentPanelExpanded = false;
  openExternalTestCount = 0;
  closedExternalTestCount = 0;
  widgetConfig: any[];
  activityCodes: any[] = [];
  forms: any[] = [];
  controlForms: any[] = [];
  testingForms: any[] = [];
  translations: any;
  editable = false;
  private unsubscribeAbility: (() => void) | null = null;
  workConditionsList: any[] = [];
  protected readonly Object = Object;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<fromRoot.State>,
    private projectsService: ProjectsService,
    private dailyReportService: DailyReportService,
    private cdRef: ChangeDetectorRef,
    private ability: Ability,
    private authService: AuthService,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    // Rules can be refreshed after this report loaded (see refreshAbilities on
    // project entry); re-evaluate editability when that happens.
    this.unsubscribeAbility = this.ability.on('updated', () => {
      if (this.dailyReport) {
        this.setEditableParam();
      }
    });

    // The widgets of the project this report belongs to: the project's own
    // widget_config when it has one, the org's otherwise. Re-resolved whenever
    // appdata or the project lands, in either order; until the route's project
    // is in the store (or while another project's is still there) the org
    // config stands. Rendered in display_order, like the + menu and the
    // mobile app.
    combineLatest([this.store.select(appDataDetails), this.store.select(projectDetails)])
      .pipe(takeUntil(this.onDestroy))
      .subscribe(([data, project]) => {
        this.widgetConfig = [
          ...resolveWidgetConfig(data, projectForRoute(project, this.route.snapshot.params.projectId)),
        ].sort((a, b) => a.display_order - b.display_order);
        this.workConditionsList = data?.workConditions || [];
      });

    this.store.select(translations)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.translations = data;
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        this.expandedSection = qp.expandedSection || null;
        this.cdRef.detectChanges();

        if (qp.expandedSection === undefined) {
          // Only close right panel if no item is selected (e.g., workday, weather detail)
          if (!qp.selectedId) {
            this.projectsService.closeRightPanel.next();
          }
          this.isCleTabChangeProgrammatic = true;
          this.expandedSectionTabIndex = 0;
        } else {
          // The section may not be on the page: a widget this project hides,
          // or one that has not rendered yet.
          $(`#${qp.expandedSection}`)[0]?.scrollIntoView({
            behavior: 'smooth', // or "auto" or "instant"
            block: 'start', // or "end"
          });

          if (qp.idx !== undefined) {
            this.isCleTabChangeProgrammatic = true;
            this.expandedSectionTabIndex = qp.idx;
          } else if (!qp.selectedId) {
            this.isCleTabChangeProgrammatic = true;
            this.expandedSectionTabIndex = 0;
          }
        }

        if (qp.selectedId !== this.selectedId) {
          const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

          if (isFormDirty) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              disableClose: true,
              data: new ConfirmDialogModel(
                'Unsaved changes',
                `There are unsaved changes.<br/>Are you sure you want to discard?`,
              ),
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.projectsService.isAnyFormDirty.next(false);
                this.selectedId = qp.selectedId || null;
                if (!qp.selectedId) {
                  this.projectsService.closeRightPanel.next();
                }
              } else {
                this.router.navigate([], {
                  queryParams: { selectedId: this.selectedId },
                  queryParamsHandling: 'merge',
                });
              }
            });
          } else {
            if (qp.selectedId) {
              this.selectedId = qp.selectedId;
            } else {
              this.selectedId = null;
              this.projectsService.closeRightPanel.next();
            }
          }
        }
      });

    this.store.select(dailyReport)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((report: any) => {
        this.dailyReport = JSON.parse(JSON.stringify(report));
        this.bidItems = this.dailyReport?.reportDetails?.bidItems || [];
        // Calculate paid status for each bid item
        this.bidItems = this.bidItems?.map(bidItem => {
          let paidCount = 0;
          let totalCount = 0;
          if (bidItem?.lineItems) { // Check if it's a multiline item
            totalCount = bidItem?.lineItems?.length;
            paidCount = bidItem?.lineItems?.filter(item => !!item?.pay_app_id)?.length;
          }
          // Add calculated properties to the bidItem object
          return {
            ...bidItem,
            paidLineItemCount: paidCount,
            totalLineItemCount: totalCount,
            isAnyLinePaid: paidCount > 0,
          };
        });

        this.activities = this.dailyReport?.reportDetails?.activities || [];
        this.notes = this.dailyReport?.reportDetails?.notes || [];
        this.weather = this.dailyReport?.reportDetails?.weather || {};
        this.deliveries = this.dailyReport?.reportDetails?.deliveries || [];
        this.usages = this.dailyReport?.reportDetails?.usages || [];
        this.issues = this.dailyReport?.reportDetails?.issues || [];
        this.labors = this.dailyReport?.reportDetails?.labors || [];
        this.equipments = this.dailyReport?.reportDetails?.equipments || [];
        this.materialTesting = this.dailyReport?.reportDetails?.materialTests || {};

        if (this.materialTesting && Object.keys(this.materialTesting)?.length > 0) {
          this.internalMaterialTestingCount = this.materialTesting?.internal?.groupedByInternalTestIdCount;
          this.openExternalTestCount = this.materialTesting.external?.openTests?.length || 0;
          this.closedExternalTestCount = this.materialTesting.external?.closedTests?.length || 0;
          this.externalMaterialTestingCount = (this.openExternalTestCount + this.closedExternalTestCount) || 0;
        }

        this.activityCodes = this.dailyReport?.reportDetails?.activity_codes || [];
        this.forms = this.dailyReport?.reportDetails?.controlForms?.dailyReportForms || [];
        this.controlForms = this.dailyReport?.reportDetails?.controlForms?.controlPointForms || [];
        this.testingForms = this.dailyReport?.reportDetails?.controlForms?.testingForms || [];

        let deliveriesCount = 0;
        let usagesCount = 0;

        this.deliveries?.forEach(delivery => {
          if (delivery.subType === 'bidItemWithMaterials') {
            deliveriesCount += delivery.materials.length;
          } else {
            deliveriesCount++;
          }
        });

        this.deliveriesCount = deliveriesCount;

        this.usages?.forEach(usage => {
          if (usage.subType === 'bidItemWithMaterials') {
            usagesCount += usage.materials.length;
          } else {
            usagesCount++;
          }
        });

        this.usagesCount = usagesCount;

        this.laborCount = 0;
        this.labors.forEach(o => this.laborCount += o.quantity);

        this.equipmentCount = 0;
        this.equipments.forEach(o => this.equipmentCount += o.quantity);

        this.contractors = (this.dailyReport?.reportDetails?.sub_contractors || []).map(sc => {
          const projectContractor = this.project?.sub_contractors?.find(c => c.value === sc.sub_contractor?.id);
          return {
            ...sc,
            sub_contractor: {
              ...sc.sub_contractor,
              prime: projectContractor?.prime ?? sc.sub_contractor?.prime,
            },
          };
        });
        this.contractorCount = this.contractors.length;

        this.openIssues = this.issues.filter(issue => isIssueStatusOpen(issue.status)).sort((a, b) => {
          return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
        });

        this.closedIssues = this.issues.filter(issue => isIssueStatusClosed(issue.status)).sort((a, b) => {
          return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
        });

        this.setEditableParam();

        this.cdRef.detectChanges();

        this.openSelectedItemFromUrlIfNeeded();
      });

    this.dailyReportService.save
      .pipe(takeUntil(this.onDestroy))
      .subscribe((params) => {
        this.saveDailyReport(params.type, params.data, params.options);
      });

    this.dailyReportService.delete
      .pipe(takeUntil(this.onDestroy))
      .subscribe((params) => {
        this.deleteFromDailyReport(params.type, params.id);
      });

    this.store.select(siteDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(site => {
        this.site = site;
      });

    this.store.select(projectDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(project => {
        this.project = project;
      });

    this.dailyReportService.openDetailsPanel
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.openDetailsPanel(data.type, data.formData);
      });
  }

  /**
   * A project refetch hands over new entry objects for the same widgets;
   * tracking by name keeps the open section and its tab groups in place.
   */
  trackWidget(index: number, widget: WidgetConfigEntry) {
    return widget?.name;
  }

  get workConditionLabel(): string {
    if (!this.dailyReport?.work_condition_code || !this.workConditionsList?.length) {
      return 'WORK DAY';
    }
    const condition = this.workConditionsList.find(o => o.value === this.dailyReport.work_condition_code);
    if (!condition) {
      return 'WORK DAY';
    }
    // Code 999 is "Workday", everything else is a non-workday reason
    if (condition.value === 999) {
      return 'WORK DAY';
    }
    return `NON-WORKDAY (${condition.label?.toUpperCase()})`;
  }

  handleExpansion(type) {
    if (this.expandedSection === type) {
      this.router.navigate([], {
        queryParams: {
          expandedSection: null,
          idx: null,
          selectedId: null,
        },
        queryParamsHandling: 'merge',
      }).then(() => {
        this.projectsService.isAnyFormDirty.next(false);

        if (this.deliveryUsageTabs) {
          this.deliveryUsageTabs._handleClick = this.onTabChange?.bind(this);
        }

        if (this.laborEquipmentTabs) {
          this.laborEquipmentTabs._handleClick = this.onTabChange?.bind(this);
        }

        if (this.materialTestingTabs) {
          this.materialTestingTabs._handleClick = this.onTabChange?.bind(this);
        }
      });
    } else {
      const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

      if (isFormDirty) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          data: new ConfirmDialogModel(
            'Unsaved changes',
            `There are unsaved changes.<br/>Are you sure you want to discard?`,
          ),
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.projectsService.closeRightPanel.next();

            this.router.navigate([], {
              queryParams: {
                expandedSection: type,
                idx: '0',
                selectedId: null,
              },
              queryParamsHandling: 'merge',
            }).then(() => {
              this.projectsService.isAnyFormDirty.next(false);

              if (this.deliveryUsageTabs) {
                this.deliveryUsageTabs._handleClick = this.onTabChange?.bind(this);
              }

              if (this.laborEquipmentTabs) {
                this.laborEquipmentTabs._handleClick = this.onTabChange?.bind(this);
              }

              if (this.materialTestingTabs) {
                this.materialTestingTabs._handleClick = this.onTabChange?.bind(this);
              }

            });
          }
        });
      } else {
        this.router.navigate([], {
          queryParams: {
            expandedSection: type,
            idx: '0',
            selectedId: null,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          this.projectsService.isAnyFormDirty.next(false);

          if (this.deliveryUsageTabs) {
            this.deliveryUsageTabs._handleClick = this.onTabChange?.bind(this);
          }

          if (this.laborEquipmentTabs) {
            this.laborEquipmentTabs._handleClick = this.onTabChange?.bind(this);
          }

          if (this.materialTestingTabs) {
            this.materialTestingTabs._handleClick = this.onTabChange?.bind(this);
          }

        });
      }


    }
  }

  private isCleTabChangeProgrammatic = false;

  onCleTabChange(event) {
    if (this.isCleTabChangeProgrammatic) {
      this.isCleTabChangeProgrammatic = false;
      return;
    }
    this.router.navigate([], {
      queryParams: { idx: `${event.index}`, selectedId: null },
      queryParamsHandling: 'merge',
    });
    this.projectsService.isAnyFormDirty.next(false);
  }

  triggerOpenDetailsPanel(type, data, index?) {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

    if (isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        data: new ConfirmDialogModel(
          'Unsaved changes',
          `There are unsaved changes.<br/>Are you sure you want to discard?`,
        ),
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.openDetailsPanel(type, data, index);
          this.projectsService.isAnyFormDirty.next(false);
        }
      });
    } else {
      this.openDetailsPanel(type, data, index);
    }
  }

  // Auto-open the side panel if the URL has a selectedId + expandedSection
  // that matches an item in the loaded daily-report data. Tracks the most
  // recently auto-opened id so the user can manually close the panel without
  // it immediately re-opening on the next data refresh.
  private openSelectedItemFromUrlIfNeeded() {
    const qp = this.route.snapshot.queryParams;
    const selectedId = qp?.['selectedId'];
    const expandedSection = qp?.['expandedSection'];
    if (!selectedId || !expandedSection) return;
    if (selectedId === this.autoOpenedSelectedId) return;

    const lookups: { type: string; items: any[] }[] = (() => {
      switch (expandedSection) {
        case 'issues': return [{ type: 'issue', items: this.issues || [] }];
        case 'item-postings': return [{ type: 'item-postings', items: this.bidItems || [] }];
        case 'activities': return [{ type: 'activity', items: this.activities || [] }];
        case 'notes': return [{ type: 'notes', items: this.notes || [] }];
        case 'delivery-usage': return [
          { type: 'delivery', items: this.deliveries || [] },
          { type: 'usage', items: this.usages || [] },
        ];
        case 'labor-equipment':
        case 'contractor-labor-equipment':
          return [
            { type: 'labor', items: this.labors || [] },
            { type: 'equipment', items: this.equipments || [] },
            { type: 'contractor', items: this.contractors || [] },
          ];
        case 'forms': return [{ type: 'form', items: this.forms || [] }];
        case 'testing-forms': return [{ type: 'testingForm', items: this.testingForms || [] }];
        case 'activity-codes': return [{ type: 'activityCode', items: this.activityCodes || [] }];
        default: return [];
      }
    })();

    for (const { type, items } of lookups) {
      const match = items?.find(item => item?.id === selectedId || item?.uuid === selectedId);
      if (match) {
        this.autoOpenedSelectedId = selectedId;
        this.openDetailsPanel(type, match);
        return;
      }
    }
  }

  openDetailsPanel(type, data, index?) {
    const newSelectedId = type === 'workday'
      ? 'workday'
      : type === 'internalTest'
        ? `${data.headingId}_${data.testId}`
        : data?.id;

    const currentSelectedId = this.route.snapshot.queryParams['selectedId'];

    const shouldRemoveQP = currentSelectedId === newSelectedId;

    const queryParams = shouldRemoveQP
      ? { selectedId: null, itType: null }
      : {
        selectedId: newSelectedId,
        ...(type === 'internalTest' && { itType: data?.type }),
      };

    // Register this manual open/close with the URL auto-open dedup so a report
    // data refresh (e.g. opening a control form triggers a store emission)
    // doesn't re-run openSelectedItemFromUrlIfNeeded and toggle the panel back.
    this.autoOpenedSelectedId = shouldRemoveQP ? null : newSelectedId;

    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
    }).then(() => {
      this.projectsService.isAnyFormDirty.next(false);
      switch (type) {
        case 'workday':
          this.projectsService.openRightPanel.next({
            component: WorkdayDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'weather':
          this.projectsService.openRightPanel.next({
            component: WeatherDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'bidItem':
          this.projectsService.openRightPanel.next({
            component: BidItemDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'item-postings':
          this.projectsService.openRightPanel.next({
            component: ItemPostingsWrapperComponent,
            data: {
              itemPostings: JSON.parse(JSON.stringify(data)),
            },
          });
          break;

        case 'activity':
          this.projectsService.openRightPanel.next({
            component: ActivityItemDetailsComponent,
            data: JSON.parse(JSON.stringify({ ...data, index })),
          });
          break;

        case 'notes':
          this.projectsService.openRightPanel.next({
            component: NotesDetailsComponent,
            data: JSON.parse(JSON.stringify({ ...data, index })),
          });
          break;

        case 'issue':
          this.projectsService.openRightPanel.next({
            component: IssueDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'delivery':
          this.projectsService.openRightPanel.next({
            component: DeliveryDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'usage':
          this.projectsService.openRightPanel.next({
            component: UsageDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'labor':
          this.projectsService.openRightPanel.next({
            component: LaborDetailsWrapperComponent,
            data: {
              laborDetails: JSON.parse(JSON.stringify(data)),
            },
          });
          break;

        case 'equipment':
          this.projectsService.openRightPanel.next({
            component: EquipmentDetailsWrapperComponent,
            data: {
              equipmentDetails: JSON.parse(JSON.stringify(data)),
            },
          });
          break;

        case 'internalTest':
          this.projectsService.openRightPanel.next({
            component: InternalTestDetailsWrapperComponent,
            data: {
              internalTestDetails: JSON.parse(JSON.stringify(data)),
            },
          });
          break;

        case 'externalTest':
          this.projectsService.openRightPanel.next({
            component: ExternalTestDetailsWrapperComponent,
            data: {
              externalTestDetails: JSON.parse(JSON.stringify(data)),
            },
          });
          break;

        case 'activity-codes':
          this.projectsService.openRightPanel.next({
            component: ActivityCodesDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'forms':
          // Generic Composable Forms (display_format='generic') render in the
          // dedicated generic renderer; all other formats keep the existing
          // control-forms renderer untouched.
          this.projectsService.openRightPanel.next({
            component: data?.control_form?.display_format === 'generic'
              ? GenericFormWrapperComponent
              : ControlFormDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'testForm':
          this.projectsService.openRightPanel.next({
            component: TestingFormDetailsWrapperComponent,
            data: JSON.parse(JSON.stringify(data)),
          });
          break;

        case 'cle-contractor':
          this.projectsService.openRightPanel.next({
            component: CleContractorDetailsWrapperComponent,
            data: {
              contractorDetails: data ? JSON.parse(JSON.stringify(data)) : null,
            },
          });
          break;

        case 'cle-labor':
          this.projectsService.openRightPanel.next({
            component: CleLaborDetailsWrapperComponent,
            data: {
              laborDetails: data ? JSON.parse(JSON.stringify(data)) : null,
            },
          });
          break;

        case 'cle-equipment':
          this.projectsService.openRightPanel.next({
            component: CleEquipmentDetailsWrapperComponent,
            data: {
              equipmentDetails: data ? JSON.parse(JSON.stringify(data)) : null,
            },
          });
          break;

        default:
          break;
      }
    });
  }

  saveDailyReport(type, data, options) {
    let baseDailyReport;
    if (Array.isArray(data)) {
      data = data.map(o => {

        if (o?.id?.includes('new_')) {
          o.id = null;
        }

        return o;
      });
    }

    this.store.select(dailyReport)
      .subscribe(dr => {
        const { reportDetails, ...rest } = JSON.parse(JSON.stringify(dr));
        baseDailyReport = rest;

        switch (type) {
          case 'workday':
            baseDailyReport.work_condition_code = data.work_condition_code;
            baseDailyReport.work_condition_comment = data.work_condition_comment;
            break;

          case 'weather':
            baseDailyReport.weather = {
              ...data,
            };
            break;

          case 'bidItems':
            const bidItemsList = baseDailyReport?.bid_items?.filter(o => relationId(o, 'bid_item') !== options?.bidItem.id) || [];

            baseDailyReport.bid_items = [
              ...bidItemsList,
              ...data,
            ];

            break;

          case 'activities':
            const activitiesList = baseDailyReport?.activities?.filter(o => o.id !== data[0]?.id);

            baseDailyReport.activities = [
              ...activitiesList,
              ...data,
            ];

            break;

          case 'notes':
            const notesList = baseDailyReport?.notes?.filter(o => o.id !== data[0]?.id) || [];

            baseDailyReport.notes = [
              ...notesList,
              ...data,
            ];

            break;

          case 'delivery':
            // FK ids (bid_item_id / material_id) are set for every row by normalizeReportLineItemIds below.
            let deliveries = baseDailyReport?.material_deliveries || [];

            // The panel has no ticket UI and sends no `tickets`: keep the stored ones.
            data = carryOverUnsentList(deliveries, data, 'tickets');

            // Remove elements which are to be updated by the new elements
            deliveries = deliveries?.filter(o => !data.map(m => m.id).includes(o?.id)) || [];

            baseDailyReport.material_deliveries = [
              ...deliveries,
              ...data,
            ];

            // Remove lines with have been deleted
            baseDailyReport.material_deliveries = baseDailyReport.material_deliveries.filter(o => !options.linesToDelete.includes(o.id));

            break;

          case 'usage':
            let usages = baseDailyReport?.material_deliveries || [];

            data = carryOverUnsentList(usages, data, 'tickets');

            usages = usages?.filter(o => !data.map(m => m.id).includes(o?.id)) || [];

            baseDailyReport.material_deliveries = [
              ...usages,
              ...data,
            ];

            break;

          case 'labor':
            // sub_contractor_id etc. come from normalizeReportLineItemIds below. The old
            // `o.sub_contractor_id = o.sub_contractor.id` here overwrote the contractor the
            // user just picked with the stale relation spread in from the GET.

            // De-dup against EVERY incoming id (the old data[0]?.id filter duplicated
            // entries 2..N when the multi-line panel saves several at once).
            baseDailyReport.labor = mergeLineItems(baseDailyReport?.labor, data, options?.linesToDelete);

            break;

          case 'equipment':
            baseDailyReport.equipment = mergeLineItems(baseDailyReport?.equipment, data, options?.linesToDelete);

            break;

          case 'issues':
            const issuesList = baseDailyReport?.issues?.filter(o => o.id !== data[0]?.id);

            baseDailyReport.issues = [
              ...issuesList,
              ...data,
            ];

            break;

          case 'activity-codes':
            const activityCodesList = baseDailyReport?.activity_codes?.filter(o => o.id !== data[0]?.id) || [];

            baseDailyReport.activity_codes = [
              ...activityCodesList,
              ...data,
            ];

            break;

          case 'forms':
            const formsList = baseDailyReport?.control_forms?.filter(o => o.id !== data[0]?.id) || [];

            baseDailyReport.control_forms = [
              ...formsList,
              ...data,
            ];

            break;

          case 'internalTest':
            let internalTestsList = baseDailyReport?.internal_tests || [];
            internalTestsList = internalTestsList?.filter(o => !data.map(m => m.id).includes(o?.id)) || [];

            baseDailyReport.internal_tests = [
              ...internalTestsList,
              ...data,
            ];

            baseDailyReport.internal_tests = baseDailyReport.internal_tests.filter(o => !options.itdToDelete.includes(o.id));

            break;

          case 'sub_contractors':
            const scList = baseDailyReport?.sub_contractors?.filter(o => o.id !== data[0]?.id) || [];
            baseDailyReport.sub_contractors = [...scList, ...data];
            break;

          default:
            break;
        }

        // Every untouched row is re-sent as the GET returned it (relation objects/strings,
        // no *_id); the API writes NULL for any *_id it doesn't get. Runs for EVERY save type.
        baseDailyReport = normalizeReportLineItemIds(baseDailyReport);

        baseDailyReport.material_deliveries =
          this.removeInvalidAndDuplicatesFromMaterialDeliveries(baseDailyReport?.material_deliveries);

        baseDailyReport.internal_tests = this.manageInternalTests(baseDailyReport?.internal_tests);

        baseDailyReport.activity_codes = this.refactorActivityCodesLines(baseDailyReport.activity_codes);

        baseDailyReport.control_forms = this.refactorControlFroms(baseDailyReport.control_forms);

        baseDailyReport.equipment = this.refactorEquipmentList(baseDailyReport.equipment);

        baseDailyReport.labor = this.refactorLaborList(baseDailyReport.labor);

        baseDailyReport.bid_items = this.refactorBidItems(baseDailyReport.bid_items);

        baseDailyReport = this.manageMedia(baseDailyReport);

        // Untouched lines re-sent from the fetched report hold the serialized link; send the api shape.
        baseDailyReport = withLinkPayloads(baseDailyReport);

        if (!options?.fromDialog) {
          this.router.navigate([], {
            queryParams: {
              matched: null,
              matchedId: null,
              selectedId: null,
            },
            queryParamsHandling: 'merge',
          });
        }

        const apiPayload = {
          params: {
            siteId: this.route.snapshot.params.siteId,
          },
          dailyReport: baseDailyReport,
          // The version this tab loaded (or last saved): the api 409s if it changed since.
          baseUpdatedAt: baseUpdatedAtFor(baseDailyReport),
          fromDialog: !!options?.fromDialog,
        };
        this.projectsService.isAnyFormDirty.next(false);
        this.store.dispatch(SaveDailyReportRequest({ payload: apiPayload }));
      }).unsubscribe();
  }

  deleteFromDailyReport(type, id) {
    let baseDailyReport;

    this.store.select(dailyReport)
      .subscribe(dr => {
        const { reportDetails, ...rest } = JSON.parse(JSON.stringify(dr));
        baseDailyReport = rest;

        switch (type) {
          case 'bidItems':
            baseDailyReport.bid_items = baseDailyReport?.bid_items?.filter(o => relationId(o, 'bid_item') !== id);
            break;

          case 'activities':
            const activities = baseDailyReport?.activities?.filter(o => o.id !== id);
            baseDailyReport.activities = activities;
            break;

          case 'notes':
            const notes = baseDailyReport?.notes?.filter(o => o.id !== id);
            baseDailyReport.notes = notes;
            break;

          case 'delivery':
          case 'usage':
            // Here id is a special case, where it will be used as an array
            baseDailyReport.material_deliveries = baseDailyReport?.material_deliveries?.filter(o => !id.includes(o.id));
            break;

          case 'labor':
            const labor = baseDailyReport?.labor?.filter(o => o.id !== id);
            baseDailyReport.labor = labor;
            break;

          case 'equipment':
            const equipment = baseDailyReport?.equipment?.filter(o => o.id !== id);
            baseDailyReport.equipment = equipment;
            break;

          case 'sub_contractors':
            const subContractors = baseDailyReport?.sub_contractors?.filter(o => o.id !== id);
            baseDailyReport.sub_contractors = subContractors;
            break;

          case 'activity-codes':
            // Lines are rebuilt as { activity_code_id } by refactorActivityCodesLines below.
            baseDailyReport.activity_codes = baseDailyReport?.activity_codes?.filter(o => o.id !== id);
            break;

          case 'forms':
            const formsList = baseDailyReport?.control_forms?.filter(o => o.id !== id);
            baseDailyReport.control_forms = formsList;
            break;

          case 'internalTest':
            // Here id is a special case, where it will be used as an array
            baseDailyReport.internal_tests = baseDailyReport?.internal_tests?.filter(o => !id.includes(o.id));
            break;

          default:
            break;
        }

        baseDailyReport = normalizeReportLineItemIds(baseDailyReport);
        baseDailyReport = this.manageMedia(baseDailyReport);
        baseDailyReport.activity_codes = this.refactorActivityCodesLines(baseDailyReport.activity_codes);
        baseDailyReport.control_forms = this.refactorControlFroms(baseDailyReport.control_forms);
        baseDailyReport.bid_items = this.refactorBidItems(baseDailyReport.bid_items);
        baseDailyReport = withLinkPayloads(baseDailyReport);

        const deletePayload = {
          params: {
            siteId: this.route.snapshot.params.siteId,
          },
          dailyReport: baseDailyReport,
          baseUpdatedAt: baseUpdatedAtFor(baseDailyReport),
        };
        this.store.dispatch(SaveDailyReportRequest({ payload: deletePayload }));
      }).unsubscribe();
  }

  manageMedia(report) {
    report.bid_items = report.bid_items?.map(bidItem => {
      bidItem.pictures = bidItem.pictures?.map(o => o.id);
      bidItem.videos = bidItem.videos?.map(o => o.id);
      return bidItem;
    });

    report.activities = report.activities?.map(activity => {
      activity.pictures = activity.pictures?.map(o => o.id);
      activity.videos = activity.videos?.map(o => o.id);
      return activity;
    });

    report.material_deliveries = report.material_deliveries?.map(materialDelivery => {
      materialDelivery.pictures = materialDelivery.pictures?.map(o => o.id);
      materialDelivery.videos = materialDelivery.videos?.map(o => o.id);
      return materialDelivery;
    });

    report.internal_tests = report.internal_tests?.map((internalTest: any) => {
      internalTest.pictures = internalTest.pictures?.map(o => o.id);
      internalTest.videos = internalTest.videos?.map(o => o.id);
      return internalTest;
    });

    report.activity_codes = report.activity_codes?.map(activityCode => {
      activityCode.pictures = activityCode.pictures?.map(o => o.id);
      activityCode.videos = activityCode.videos?.map(o => o.id);
      return activityCode;
    });

    report.sub_contractors = report.sub_contractors?.map(subContractor => {
      subContractor.pictures = subContractor.pictures?.map(o => o.id);
      subContractor.videos = subContractor.videos?.map(o => o.id);
      if (subContractor.sub_contractor !== undefined) {
        subContractor.sub_contractor_id = relationId(subContractor, 'sub_contractor');
        delete subContractor.sub_contractor;
      }
      return subContractor;
    });

    // Labor / equipment media come back from the GET as attachment objects; the API wants ids.
    report.labor = report.labor?.map(labor => ({
      ...labor,
      pictures: toIdList(labor?.pictures),
      videos: toIdList(labor?.videos),
    }));

    report.equipment = report.equipment?.map(equipment => ({
      ...equipment,
      pictures: toIdList(equipment?.pictures),
      videos: toIdList(equipment?.videos),
    }));

    report.control_forms = report.control_forms?.map(controlForm => {
      controlForm.pictures = controlForm.pictures?.map(o => o.id);
      controlForm.videos = controlForm.videos?.map(o => o.id);
      controlForm.lines.forEach(cf => {
        cf.pictures = cf.pictures?.map(o => o.id);
        cf.videos = cf.videos?.map(o => o.id);
      });
      return controlForm;
    });

    return report;
  }

  removeInvalidAndDuplicatesFromMaterialDeliveries(arr) {
    // Step 1: Remove objects with invalid data
    const filteredArray = arr.filter(item => {
      const hasInvalidData =
        (!item.latitude || item.longitude) &&
        item.quantity === 0 &&
        item.received === null &&
        item.used === null &&
        Array.isArray(item.pictures) && item.pictures.length === 0 &&
        !item.comment;

      return !hasInvalidData;
    });

    const duplicateHeaders = filteredArray.filter((item) => {
      return item.quantity === 0 &&
        item.received === null &&
        item.used === null; // Keep all other items
    }) || [];

    const remaining = filteredArray.filter((item) => {
      return item.quantity !== 0 ||
        item.received !== null ||
        item.used !== null;
    }) || [];

    return [
      ...remaining,
      ...(duplicateHeaders[duplicateHeaders.length - 1] ? [duplicateHeaders[duplicateHeaders.length - 1]] : []),
    ];
  }

  refactorActivityCodesLines(activityCodes) {
    activityCodes?.forEach(activityCode => {
      if (activityCode?.lines?.length > 0) {
        activityCode?.lines?.forEach((lineItem, index) => {
          if (lineItem['activity_code_id'] === undefined) {
            activityCode.lines[index] = {
              activity_code_id: relationId(lineItem, 'activity_code'),
            };
          }

          lineItem.id = null;
        });
      }
    });

    return activityCodes;
  }

  refactorControlFroms(controlFroms) {
    if (controlFroms?.length > 0) {
      controlFroms.forEach(cf => {
        if (cf) {
          cf.control_form_id = relationId(cf, 'control_form');
        }

        if (cf?.lines.length > 0) {
          cf?.lines.forEach((lineItem) => {
            lineItem.id = null;
          });
        }

        if (cf?.signatures?.length > 0) {
          cf?.signatures.forEach((signature: any) => {
            signature.id = null;
          });
        }
      });
    }

    return controlFroms;
  }

  refactorEquipmentList(equipments) {
    if (equipments?.length > 0) {
      equipments?.forEach(equipment => {
        if (equipment) {
          equipment.sub_contractor_id = relationId(equipment, 'sub_contractor');
        }
      });
    }

    return equipments;
  }

  refactorLaborList(labors) {
    if (labors?.length > 0) {
      labors?.forEach(labor => {
        if (labor) {
          labor.sub_contractor_id = relationId(labor, 'sub_contractor');
        }
      });
    }

    return labors;
  }

  refactorBidItems(bidItems) {
    if (!bidItems?.length) return bidItems;

    return bidItems.map(item => ({
      id: item.id,
      bid_item_id: relationId(item, 'bid_item'),
      // record_by_station lines: the API stores station/heading only from these ids.
      station_id: relationId(item, 'station'),
      heading_id: relationId(item, 'heading'),
      bid_item_material_set_id: relationId(item, 'bid_item_material_set'),
      ...(item.rollup_quantity_manual !== undefined ? { rollup_quantity_manual: item.rollup_quantity_manual } : {}),
      quantity: item.quantity,
      comment: item.comment || null,
      latitude: item.latitude || null,
      longitude: item.longitude || null,
      start_of_work: item.start_of_work || false,
      station_break: item.station_break || false,
      pictures: item.pictures || [],
      videos: item.videos || [],
      annotations: item.annotations?.map(a => a.id || a) || [],
      field_values: item.field_values || [],
      group_values: item.group_values || [],
      station_range: item.station_range || null,
      location: item.location || null,
      geometry: item.geometry || null,
      // Key presence matters (absent = link untouched); withLinkPayloads converts it before the save.
      ...(item.map_feature_link !== undefined ? { map_feature_link: item.map_feature_link } : {}),
      // Round-trip external-source rows (ESRI/ArcGIS survey data) exactly as mobile
      // does. Omitting the key entirely used to make the API wipe them on every
      // save. Only send it when we actually have the collection loaded -- an
      // absent key leaves the stored rows untouched.
      ...(item.sources !== undefined ? { sources: item.sources } : {}),
      sub_contractor_id: relationId(item, 'sub_contractor'),
      materials: (item.materials || []).map(m => ({
        bid_item_material_set_id: relationId(m, 'bid_item_material_set'),
        bid_item_material_set_material_id: relationId(m, 'bid_item_material_set_material'),
        material_id: relationId(m, 'material'),
        quantity: m.quantity,
        group_values: m.group_values || null,
      })),
    }));
  }

  onTabChange(tab) {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

    if (isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        data: new ConfirmDialogModel(
          'Unsaved changes',
          `There are unsaved changes.<br/>Are you sure you want to discard?`,
        ),
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.router.navigate([], {
            queryParams: {
              idx: `${tab.position}`,
              selectedId: null,
            },
            queryParamsHandling: 'merge',
          }).then(() => {
            this.projectsService.isAnyFormDirty.next(false);
            this.projectsService.closeRightPanel.next();
          });
        }
      });
    } else {
      this.router.navigate([], {
        queryParams: {
          idx: `${tab.position}`,
          selectedId: null,
        },
        queryParamsHandling: 'merge',
      }).then(() => {
        this.projectsService.isAnyFormDirty.next(false);
        this.projectsService.closeRightPanel.next();
      });
    }
  }

  ngAfterViewInit() {
    if (this.deliveryUsageTabs) {
      this.deliveryUsageTabs._handleClick = this.onTabChange?.bind(this);
    }

    if (this.laborEquipmentTabs) {
      this.laborEquipmentTabs._handleClick = this.onTabChange?.bind(this);
    }

    if (this.materialTestingTabs) {
      this.materialTestingTabs._handleClick = this.onTabChange?.bind(this);
    }

  }

  manageInternalTests(internalTests) {
    // Explicit station_id/heading_id (set by the internal-test panel, which sends no
    // station/heading objects) used to be nulled here, so station tests never saved.
    return Array.isArray(internalTests)
      ? internalTests.map(internalTest => withRelationIds(internalTest, ['station', 'heading']))
      : internalTests;
  }

  setEditableParam() {
    this.editable = this.ability.can('create', subject('DailyReport', this.dailyReport));
    this.cdRef.detectChanges();

    // Logout clears the ability and the store, which lands here via the
    // `updated` listener and the report subscription. Navigating then would
    // supersede the in-flight /login navigation and strand a logged-out user
    // on this page, so only sync the query param while signed in and only
    // when it actually changes.
    const value = this.editable ? '1' : '0';
    if (!this.authService.isLoggedIn() || this.route.snapshot.queryParams['editable'] === value) {
      return;
    }

    this.router.navigate([], {
      queryParams: { editable: value },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.unsubscribeAbility?.();
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
